export const LOAD_REQUEST = 'DVR_HEALTH/LOAD_REQUEST';
export const LOAD_SUCCESS = 'DVR_HEALTH/LOAD_SUCCESS';
export const LOAD_FAILURE = 'DVR_HEALTH/LOAD_FAILURE';
export const LOAD_REPORT_SUCCESS = 'DVR_HEALTH/LOAD_REPORT_SUCCESS';
export const LOAD_REPORT_FAILURE = 'DVR_HEALTH/LOAD_REPORT_FAILURE';
export const CLEAR_REPORT_FILE = 'DVR_HEALTH/CLEAR_REPORT_FILE';
export const CLEAR = 'DVR_HEALTH/CLEAR';
export const DVR_UNPAIR_SUCCESS = 'DVR_HEALTH/DVR_UNPAIR_SUCCESS';
export const DVR_UNPAIR_FAILURE = 'DVR_HEALTH/DVR_UNPAIR_FAILURE';
export const GET_SUBSCRIPTION_REQUEST = 'DVR_HEALTH/GET_SUBSCRIPTION_REQUEST';
export const GET_SUBSCRIPTION_SUCCESS = 'DVR_HEALTH/GET_SUBSCRIPTION_SUCCESS';
export const GET_SUBSCRIPTION_FAIL = 'DVR_HEALTH/GET_SUBSCRIPTION_FAIL';
export const SUBSCRIBE_REQUEST = 'DVR_HEALTH/SUBSCRIBE_REQUEST';
export const SUBSCRIBE_SUCCESS = 'DVR_HEALTH/SUBSCRIBE_SUCCESS';
export const SUBSCRIBE_FAIL = 'DVR_HEALTH/SUBSCRIBE_FAIL';
export const UNSUBSCRIBE_REQUEST = 'DVR_HEALTH/UNSUBSCRIBE_REQUEST';
export const UNSUBSCRIBE_SUCCESS = 'DVR_HEALTH/UNSUBSCRIBE_SUCCESS';
export const UNSUBSCRIBE_FAIL = 'DVR_HEALTH/UNSUBSCRIBE_FAIL';
export const LOAD_TOTALDVR_SUCCESS = 'DVR_HEALTH/LOAD_TOTALDVR_SUCCESS';
export const LOAD_TOTALDVR_FAILURE = 'DVR_HEALTH/LOAD_TOTALDVR_FAILURE';
